import { auth } from '../firebase/config';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");
    return await user.getIdToken();
};

const fetchWithAuth = async (url, options = {}) => {
    const token = await getAuthToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
    };
    const response = await fetch(`${API_URL}${url}`, { ...options, headers });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
    }
    return response.json();
};

export const getMyCourses = async (clientId) => {
    return fetchWithAuth(`/learning/my-courses/${clientId}`);
};

export const getCourseContent = async (courseId, clientId) => {
    return fetchWithAuth(`/learning/course/${courseId}?clientId=${clientId}`);
};

export const completeLesson = async (lessonId, clientId) => {
    return fetchWithAuth(`/learning/lesson/${lessonId}/complete`, {
        method: 'POST',
        body: JSON.stringify({ clientId })
    });
};

export const submitModuleEvaluation = async (moduleId, clientId, answers) => {
    return fetchWithAuth(`/learning/module/${moduleId}/evaluate`, {
        method: 'POST',
        body: JSON.stringify({ clientId, answers })
    });
};
